<template>
<div id="trafico-embarque">

    <v-form ref="form" lazy-validation>
        <div class="row">
            <div class="col-xs-1">

            </div>
            <div class="col-xs-10"></div>
        </div>
        <div v-for="(embarque, index) in this.$store.state.embarques_trafico" v-bind:key="index" @keyup.enter="nextTab">
            <v-row style="flex-wrap: nowrap;">
                <v-col cols="6" class="flex-grow-0 flex-shrink-0">
                    <v-textarea outline rows="2" row-height="20" :name="'nombre['+index+']'" label="Descripción Genérica" autocomplete="off" v-model="embarque.descripcion" :rules="[rules.required]"></v-textarea>
                </v-col>
            </v-row>
            <v-row style="flex-wrap: nowrap;">
                <v-col cols="12" class="flex-grow-0 flex-shrink-0">
                    <v-trafico-embarque :padre="index" :key="index*100"></v-trafico-embarque>
                </v-col>
            </v-row>
        </div>
    </v-form>
    <p />
    <p />
    <p />
</div>
</template>

<script>
import Vue from "vue";
import traficoEmbarqueDetalle from "@/components/trafico/DetalleEmbarque.vue";
import {
    request
} from "http";
import {
    mapState
} from "vuex";
import axios from "axios";

export default {
    components: {
        "v-trafico-embarque": traficoEmbarqueDetalle
    },

    created: function () {
        this.URL = this.$hostname + 'traficos/';
        this.cargar();
        this.formUpdated = false;
        this.$watch('embarques_trafico', this.formChanged, {
            deep: true
        });
        this.$root.$on("formDetalleChanged", (val) => {
            this.formUpdated = true;
        });
        //if(this.$store.state.embarques_trafico.length == 0)
        //  this.$store.state.embarques_trafico.push( Vue.util.extend({}, this.embarque) );

    },
    beforeDestroy: function () {
        this.embarques = [];
        this.$store.state.embarques_trafico = [];
    },
    computed: mapState([
        // map this.count to store.state.count
        "embarques_trafico"
    ]),

    methods: {
        nextTab() {
            this.$emit('nextTab', 3);
        },
        addNew: function () {
            // this.embarques.push(Vue.util.extend({}, this.embarque));

            this.$store.state.embarques_trafico.push(Vue.util.extend({}, this.embarque));
        },
        remove: function (index) {
            //  Vue.delete(this.embarques, index);
            Vue.delete(this.$store.state.embarques_trafico, index);
        },
        cargar: function () {
            var referencia = this.$local_storage.get("referencia");
            var rfc = this.$local_storage.get("rfc");
            if (referencia != null && referencia.trim() != "") {
                var datos = {
                    rfc: rfc,
                    referencia: referencia
                };
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                axios
                    .post(this.URL + "obtener/", datos)
                    .then((res) => {
                        if (typeof res.data !== "undefined") {
                            this.embarques = res.data.embarques;
                            this.$store.state.embarques_trafico = res.data.embarques;
                            if (res.data.embarques.length == 0)
                                this.addNew();
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener los registros de embarque"
                            //showConfirmButton: false,
                        });
                        console.log(err.response);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.formUpdated = false;
                    });
            }
        },

        save(resolve) {
            if (this.$refs.form.validate()) {
                if (this.formUpdated == true) {
                    this.$root.$dialogLoader.show('Espere un momento por favor..');
                    const datos = {
                        rfc: this.$local_storage.get("rfc"),
                        referencia: this.$local_storage.get("referencia"),
                        embarques: this.$store.state.embarques_trafico
                    };

                    var metodo = "put";
                    var urlCliente = this.$hostname + "traficos/actualizar/";

                    axios
                        .put(urlCliente, datos, {
                            "Content-type": "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "cache-control": "no-cache"
                        })
                        .then((response) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "Los datos de embarque se guardaron correctamente",
                                footer: ""
                            });
                            this.formUpdated = false;
                            this.$root.$dialogLoader.hide();
                            resolve(true);
                        })
                        .catch((error) => {
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos"
                            });
                            this.$root.$dialogLoader.hide();
                            resolve(false);
                        });
                } else
                    resolve(true);

            } else {

                this.$swal({
                    type: "info",
                    title: "Cuidado",
                    text: 'Datos incompletos en el formulario. Favor de verificar.',
                    footer: ""
                });
                resolve(false);
            }
        },
        formChanged: function (newV, oldV) {
            this.formUpdated = true;
        }
    },
    data: () => ({
        fab: false,
        loading: false,
        show_loading: false,
        URL: "",
        formUpdated: false,
        embarque: {
            descripcion: "",
            especificaciones: []
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        embarques: []
    })
};
</script>
